import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Image404 from "assets/img/image404.png";
import "./styles.scss";
import { ListRoutes } from "router/routes";

export const ScreenNotFound = () => {
  const navigate = useNavigate();

  const goBackHome = useCallback(() => {
    navigate(ListRoutes.HOME);
  }, [navigate]);

  return (
    <div className="ticket-404">
      <img
        src={Image404}
        alt="không tìm thấy trang"
        className="ticket-404-img"
      />
      <p className="ticket-404-desc">
        Xin lỗi, trang bạn truy cập không tồn tại.
      </p>
      <Button
        type="primary"
        icon={<ArrowLeftOutlined />}
        onClick={goBackHome}
        style={{ marginTop: "10px" }}
      >
        Trang chủ
      </Button>
    </div>
  );
};
